import { ActivityStats } from 'types/interfaces/activity';

// The Pulse trades tile (design pass 4, 2026-09-29; label per pass 5): "new
// trades in the last day" over the rolling PULSE_TRADES_WINDOW_H window,
// falling back to the all-time completed count when the day is empty. The tile
// never renders 0: an empty day shows all time, and a database with no
// completed trades at all shows the loading dash. Pure, so the fallback is
// unit-tested.

export const PULSE_TRADES_DAY_LABEL = 'new trades in the last day';
export const PULSE_TRADES_ALL_TIME_LABEL = 'trades all time';

export interface PulseTradesTile {
  /** undefined renders the dash */
  value: number | undefined;
  label: string;
}

export const pulseTradesTile = (stats: ActivityStats | undefined): PulseTradesTile => {
  const day = stats?.tradesLast24h;
  if (typeof day === 'number' && day > 0) {
    return { value: day, label: PULSE_TRADES_DAY_LABEL };
  }
  const allTime = stats?.tradesAllTime;
  if (typeof allTime === 'number' && allTime > 0) {
    return { value: allTime, label: PULSE_TRADES_ALL_TIME_LABEL };
  }
  // Nothing positive to show (old backend without the fields, or no trades ever)
  return { value: undefined, label: typeof day === 'number' ? PULSE_TRADES_ALL_TIME_LABEL : PULSE_TRADES_DAY_LABEL };
};
